import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import { Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MAT_MENU_DEFAULT_OPTIONS, MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { AppActions } from '@app/store/actions';
import * as fromRoot from '@app/store/reducers';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'am-export-menu',
  templateUrl: './export-menu.component.html',
  styleUrls: ['./export-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: MAT_MENU_DEFAULT_OPTIONS,
      useValue: {
        overlayPanelClass: 'export-menu-panel',
      },
    },
  ],
  imports: [MatIconButton, MatMenuTrigger, MatIcon, MatMenu, MatMenuItem, NgOptimizedImage, AsyncPipe],
  standalone: true,
})
export class ExportMenuComponent {
  @Input() urlPath: string;

  exportAnalysisRunning$: Observable<boolean>;

  private readonly _store = inject<Store<fromRoot.State>>(Store);

  constructor() {
    this.exportAnalysisRunning$ = this._store.pipe(select(fromRoot.getExportAnalysisRunning));
  }

  exportAnalysisResults(): void {
    this._store.dispatch(AppActions.exportAnalysisResults());
  }

  exportCsv(): void {
    this._store.dispatch(AppActions.exportProjectAsCsv());
  }
}
